import { useTimeByInsightsTimeframe as _useTimeByInsightsTimeframe } from '@griply/hooks';
import { InsightsTimeframes, Timestamp, WeekDays } from '@griply/types';
import { useToday } from 'shared/contexts/today';

export type Options = {
  weekStartsOn: WeekDays;
  allMonthWeeks?: boolean;
  quarterRoundedToWeeks?: boolean;
  yearRoundedToWeeks?: boolean;
  weekEndsWithStartOfDay?: boolean;
  referenceDate?: Timestamp;
};

export const useTimeByInsightsTimeframe = (
  timeframe: InsightsTimeframes,
  { referenceDate, ...options }: Options,
) => {
  const today = useToday();
  return _useTimeByInsightsTimeframe(timeframe, {
    ...options,
    today: referenceDate ?? today,
  });
};
